import { useCallback, useEffect } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { makeBanditAttack } from "../../../../../types/BanditAttack";
import { isLastMessageMatching } from "../../../../../types/Message";
import { isDead } from "../../../../../types/Player";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { selectSettings } from "../../../../settings/settingsSlice";
import { useTwitchManager } from "../../../../twitch/TwitchManager";
import { fleeFromRiders, selectGame, startFightingBandits, stopFightingBandits } from "../../../gameSlice";

let __bandit_attack_timer: any | undefined = undefined;

export default function BanditAttackButtons() {
    const dispatch = useAppDispatch();
    const twitch = useTwitchManager();
    const { status, banditAttack, players, inventory, messages } = useAppSelector(selectGame);
    const { huntingDuration } = useAppSelector(selectSettings);

    const gettingAttacked = status === 'Playing' && isLastMessageMatching(messages, message => message.type === 'Riders Approaching');
    const fighters = players.filter(player => !isDead(player) && player.active);

    const fightEnabled = (banditAttack === null || banditAttack.result !== undefined)
        && fighters.length > 0
        && inventory.rifles.amount > 0
        && inventory.bullets.amount > 0;
    
    const fleeEnabled = (banditAttack === null || banditAttack.result !== undefined);

    const startAttack = useCallback(() => {
        const attack = makeBanditAttack(fighters.map(player => player.name));
        twitch.sendMessage(`@everybody Type the following word as quickly as possible: ${attack.word}`);
        dispatch(startFightingBandits(attack));
    }, [dispatch, twitch, fighters]);

    const stopAttack = useCallback(() => {
        if (banditAttack !== null && !banditAttack.result) {
            dispatch(stopFightingBandits());
        }
    }, [banditAttack, dispatch]);

    const flee = () => dispatch(fleeFromRiders());

    useEffect(() => {
        if (!!__bandit_attack_timer && (!banditAttack || !!banditAttack.result)) {
            clearTimeout(__bandit_attack_timer);
            __bandit_attack_timer = undefined;
        } else if (!__bandit_attack_timer && !!banditAttack && !banditAttack.result) {
            const now = new Date().getTime();
            const dt = now - banditAttack.start;
            const time = (huntingDuration * 1000) - dt;
            if (time > 0) {
                __bandit_attack_timer = setTimeout(() => stopAttack(), time);
            } else {
                stopAttack();
            }
        }
    }, [banditAttack, huntingDuration, stopAttack]);

    if (gettingAttacked) {
        return (
            <ButtonGroup className="mb-1" vertical>
                <Button variant="primary" className="text-truncate" onClick={startAttack} disabled={!fightEnabled}>Fight Bandits</Button>
                <Button variant="primary" className="text-truncate" onClick={flee} disabled={!fleeEnabled}>Flee from Bandits</Button>
            </ButtonGroup>
        );
    } else {
        return null;
    }
}